import { render, staticRenderFns } from "./FunnelIcon.vue?vue&type=template&id=486c5f95&"
import script from "./FunnelIcon.vue?vue&type=script&lang=js&"
export * from "./FunnelIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports